var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 1080",
    style: {
      enableBackground: "new 0 0 1920 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F6F4F9;}\n\t.st1{fill:#FAAA19;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M431.1,603.3c0-59.3,44-92.3,88-92.3c40.5,0,69,22,78,56.3l-22.8,8c-6.7-26.8-26.3-41.7-55.3-41.7 c-32.3,0-63,23.5-63,69.8c0,46.2,30.8,70,63,70c30.3,0,49.3-18.3,56.5-42.5l21.8,8c-9.5,33.3-37.5,57-78.3,57 C473.4,695.8,431.1,662.5,431.1,603.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M664.4,695.8c-28,0-45-21-45-48.2v-75.8h23.5v72.3c0,16.5,7.5,31,27.3,31c19,0,28.5-12.5,28.5-30.8v-72.5h23.5 v98c0,9.5,0.8,18,1.3,22.3H701c-0.5-2.7-1-9.5-1-14.5C693.4,690,678.4,695.8,664.4,695.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M788.2,571.8h26v21.3h-26v62.5c0,11,4.5,16.5,16.8,16.5c3,0,7.2-0.5,9.2-1v20c-2,0.7-8,2.2-16,2.2 c-20.5,0-33.5-12.5-33.5-34.2v-66h-23v-21.3h6.5c13,0,18.5-8,18.5-18.5v-19.5h21.5V571.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M876.2,571.8h26v21.3h-26v62.5c0,11,4.5,16.5,16.8,16.5c3,0,7.2-0.5,9.2-1v20c-2,0.7-8,2.2-16,2.2 c-20.5,0-33.5-12.5-33.5-34.2v-66h-23v-21.3h6.5c13,0,18.5-8,18.5-18.5v-19.5h21.5V571.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M935.9,509.3c9.5,0,17,7.5,17,17c0,9.3-7.5,16.7-17,16.7c-9.2,0-16.7-7.5-16.7-16.7 C919.2,516.8,926.7,509.3,935.9,509.3z M924.4,692V571.8h23.3v120.3L924.4,692L924.4,692z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M999.6,692h-23.5V571.8h23v17.3c8.8-15,23-20.7,37-20.7c28.8,0,43,20.7,43,47.5v76.3h-23.5v-72.3 c0-16.7-7-30.2-28-30.2c-18.5,0-28,14.8-28,33V692z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1125.2,693.3c1.8,16.7,14.5,29.5,32.7,29.5c25.3,0,36.8-13,36.8-39v-17.3c-5.8,11-18.8,19.8-36.8,19.8 c-32,0-55.2-24.3-55.2-58.3c0-32.5,22.3-58.5,55.2-58.5c18.5,0,31,7,37,19v-16.8h23.2V683c0,30.5-15,60.3-60.3,60.3 c-30,0-52.5-19-55.5-44.8L1125.2,693.3z M1195.7,628c0-23.2-14-38.5-34.2-38.5c-20.8,0-34.8,15.3-34.8,38.5 c0,23.5,13.5,38.5,34.8,38.5C1181.7,666.5,1195.7,651.3,1195.7,628z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1300.4,619.5h-26.5V692h-24.8V514.8h66.7c33.5,0,54.3,23.5,54.3,52.8c0,25.5-16.2,45.2-43,50.2l42.3,74.3 h-28.5L1300.4,619.5z M1311.4,597.5c20,0,33.5-11.8,33.5-30c0-18.8-13.5-30.8-33.5-30.8h-37.5v60.8H1311.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1504,631.8c0,36.8-25.5,64-61.5,64s-61.5-27.2-61.5-64c0-36.5,25.5-63.8,61.5-63.8S1504,595.3,1504,631.8z  M1480,631.8c0-27.7-17.5-42.8-37.5-42.8s-37.5,15-37.5,42.8c0,28,17.5,43,37.5,43S1480,659.8,1480,631.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1644.3,631.8c0,36.8-25.5,64-61.5,64s-61.5-27.2-61.5-64c0-36.5,25.5-63.8,61.5-63.8 S1644.3,595.3,1644.3,631.8z M1620.3,631.8c0-27.7-17.5-42.8-37.5-42.8s-37.5,15-37.5,42.8c0,28,17.5,43,37.5,43 S1620.3,659.8,1620.3,631.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1664.7,692V571.8h22.5v16c7.5-13.2,22.5-19.5,36.5-19.5c15,0,29.5,7.2,36,22.7c9.5-17.3,25-22.7,40.3-22.7 c21,0,41.5,14.2,41.5,45.7v78h-23.2v-75.5c0-15.7-7.7-27.5-25.5-27.5c-16.5,0-27.7,13-27.7,30.3V692h-23.5v-75.5 c0-15.5-7.5-27.5-25.5-27.5c-16.7,0-28,12.5-28,30.5V692H1664.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M417.1,464.6H206.5V336.7h210.6c9.3,0,16.8,7.5,16.8,16.8v94.4C433.9,457.1,426.4,464.6,417.1,464.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M317.3,675.3v-28.8c0-9.3-7.5-16.8-16.8-16.8h-94V692h94C309.8,692,317.3,684.5,317.3,675.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.5,483.2H95.3c-9.3,0-16.8,7.5-16.8,16.8v94.4c0,9.3,7.5,16.8,16.8,16.8h111.2V483.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrLogoWhite);
export default __webpack_public_path__ + "static/media/cr-logo-white.c37d2be368308aec060f2af92a1c24b0.svg";
export { ForwardRef as ReactComponent };